<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <span class="title">Grosor del plastificado</span>
  <div class="section flex flex-col gap-4">
    <span class="section_title">¿En qué afectan las micras?</span>
    <p class="section_info">
      Menos micras (80) significa más flexibilidad y menor dureza. Ideal para documentos maleables.
    </p>
    <p class="section_info">Más micras (250) implica más rigidez y mayor dureza. Perfecto para documentos duraderos.</p>
  </div>
</div>
